import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useAuth } from "@/lib/contexts/auth.context";
import { User } from "lucide-react";
import { useEffect, useState } from "react";
import { ProfileForm } from "./components/profileForm.component";
import { SystemRole } from "@/lib/auth/auth.types";
/**
 * This is the profile page.
 * It is used to display the user's profile information.
 *
 *
 */
const ProfilePage = () => {
	const { user, organizations } = useAuth();
	const [userData, setUserData] = useState<{
		name: string;
		email: string;
	} | null>(null);
	useEffect(() => {
		if (user) {
			setUserData({
				name: user.displayName || "",
				email: user.email || "",
			});
		}
	}, [user]);

	return (
		<div className="min-h-screen bg-background p-6">
			<div className="max-w-2xl mx-auto">
				<header className="mb-6">
					<h1 className="text-2xl font-semibold mb-2 flex items-center">
						<User className="mr-2 h-6 w-6" />
						Mein Profil
					</h1>
					<h3 className="text-sm opacity-90 mt-1">
						Hier kannst du deine persönlichen Daten verwalten
					</h3>
				</header>

				<Card className="shadow-md">
					<CardHeader className="bg-card border-b">
						<CardTitle className="text-xl">Persönliche Informationen</CardTitle>
					</CardHeader>
					<CardContent className="p-6">
						{userData && <ProfileForm />}
					</CardContent>
				</Card>

				{user?.systemRoles.includes(SystemRole.PLATFORM_MANAGER) && (
					<Card className="shadow-md">
						<CardHeader className="bg-card border-b">
							<CardTitle className="text-xl">Organisationen</CardTitle>
						</CardHeader>
						<CardContent className="p-6">
							<div className="flex flex-col gap-4">
								<p>Du bist in folgenden Organisationen Mitglied:</p>
								<ul>
									{organizations.map((orga) => (
										<li key={orga.organizationId}>{orga.organizationId}</li>
									))}
								</ul>
							</div>
						</CardContent>
					</Card>
				)}
			</div>
		</div>
	);
};

export default ProfilePage;
